import { configureStore } from "@reduxjs/toolkit";
import { selfCheckinSlice } from "../reducer/selfCheckinSlice";

export const store = configureStore({
    reducer: {
        checkin: selfCheckinSlice.reducer,
    },
});
